import React, { useState } from "react";
import { Zap, Phone, Menu, X } from "lucide-react";

const links = [
  { href: "#szolgaltatasok", label: "Szolgáltatások" },
  { href: "#ai", label: "AI Eszközök" },
  { href: "#rolunk", label: "Rólunk" },
  { href: "#arak", label: "Árak" },
  { href: "#kapcsolat", label: "Kapcsolat" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-[#262626] backdrop-blur-xl bg-black/80"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-8 py-4">
        <a href="#top" data-testid="logo" className="flex items-center gap-2 group">
          <div className="w-10 h-10 bg-[#FFD700] flex items-center justify-center">
            <Zap className="w-6 h-6 text-black" strokeWidth={3} />
          </div>
          <div className="font-heading uppercase leading-none">
            <div className="text-xl tracking-tighter">VARGAVOLT</div>
            <div className="text-[10px] text-[#FFD700] tracking-[0.4em]">/ KFT.</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label}`}
              className="font-mono text-sm uppercase tracking-wider text-[#A3A3A3] hover:text-[#FFD700] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="tel:+36204565627"
          data-testid="header-emergency-btn"
          className="hidden md:inline-flex btn-danger text-sm"
        >
          <Phone className="w-4 h-4" /> 0-24 HIBAELHÁRÍTÁS
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 border border-[#262626] text-white"
          aria-label="menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black border-t border-[#262626]">
          <nav className="flex flex-col px-4 py-4 gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-mono uppercase text-[#A3A3A3] hover:text-[#FFD700] py-2"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:+36204565627"
              data-testid="mobile-emergency-btn"
              className="btn-danger w-full justify-center mt-2"
            >
              <Phone className="w-4 h-4" /> 0-24 HÍVÁS
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
